// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"e5879d2b","179":"81358e52","241":"14ac3843","446":"32b16882","457":"7868067e","460":"84362f36","488":"22b449f6","728":"bfc9190a","730":"a16388cd","879":"24575559","969":"d1a4e13f","979":"e941a241","997":"dea93a40"}[chunkId] + ".chunk.js";
};